import React, { useState } from 'react'
import { NormalPopover } from '../PopOver/PopOver2';
import { Button, Typography } from '..';
import { CloseRoundedIcon, FilterIcon } from '../../../theme/icons';
import propTypes from "prop-types"
import { useClickOutside } from '../../useOutsideClick';

export const Filter = React.memo(({ content = <></>, ...rest }) => {
    const { active = false } = rest
    const [popover, setPopover] = useState(false);
    const ref = React.createRef();
    const handleOpenPopover = () => setPopover(!popover);

    const ContentComponent = ({ open = false, close = () => null, ...rest }) => (
        <div className='bg-white border border-secondary-200 rounded-md p-3'>
            <div className='flex justify-between w-full'>
                <Typography variant="lg" className="font-semibold" text={"Filter by"} />
                <Button
                    variant="secondary"
                    loaderText={""}
                    onClick={() => close()}
                    className="flex h-fit w-fit items-center justify-end p-1 gap-0  bg-transparent  border-0"
                    icon={<CloseRoundedIcon className={'bg-white p-0.5'} />} text=" " />
            </div>
            {open && React.cloneElement(content, { close , setPopover})}
        </div>
    );
    useClickOutside(ref, () => setPopover(false))
    return (<div ref={ref}>
        <NormalPopover handleOpenPopover={handleOpenPopover} open={popover} className={"absolute inset-0 z-[999] left-[-18rem] right-5 top-5"}
            content={<ContentComponent handleOpenPopover={handleOpenPopover} />} >
            <Button text="" title="Filter" onClick={handleOpenPopover} className={`p-2 h-fit w-fit rounded-full relative ${popover ? "bg-primary-500 hover:bg-primary-300 " : " hover:bg-primary-50"}`}
                variant="secondary" icon={
                    <>
                        <FilterIcon className={`${popover ? "stroke-white" : ""} h-4 w-4 min-w-4`} />
                        {active && <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>}
                    </>
                } />
        </NormalPopover></div>)
})

Filter.propTypes = {
    content: propTypes.any
}